import { render, staticRenderFns } from "./StudiKasusTable.vue?vue&type=template&id=1749e609&"
import script from "./StudiKasusTable.vue?vue&type=script&lang=js&"
export * from "./StudiKasusTable.vue?vue&type=script&lang=js&"
import style0 from "./StudiKasusTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports